import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { toggleQueuedPost, orgInitialState, setDraftPostAutoPublishAt } from 'redux/modules/composeboxForm';
import { Calendar, FormAccordionSection } from 'components';
import moment from 'moment';
import * as styles from './Composebox.scss';
import DatePicker from 'components/DatePicker/DatePicker';
import schedule from '../../redux/modules/schedule';
var DraftAutoScheduleArea = (_dec = connect(function (state) {
  var _state$schedule$posts;

  var orgId = state.organization.current.id;
  return {
    config: state.config,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    selectedTimezone: state.organization.selectedOrgDetails[orgId].OrganizationTimezone,
    timezone: state.organization.current.OrganizationTimezone && state.organization.current.OrganizationTimezone.details ? state.organization.current.OrganizationTimezone.details : {
      utc_offset: {
        hours: new Date().getTimezoneOffset() / 60
      }
    },
    orgPosts: (_state$schedule$posts = state.schedule.posts) !== null && _state$schedule$posts !== void 0 && _state$schedule$posts[orgId] ? state.schedule.posts[orgId].filter(function (p) {
      return p.type !== "AD";
    }) : [],
    loadingPosts: state.schedule.loadingPosts
  };
}, {
  toggleQueuedPost: toggleQueuedPost,
  setDraftPostAutoPublishAt: setDraftPostAutoPublishAt
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(DraftAutoScheduleArea, _Component);

  var _super = _createSuper(DraftAutoScheduleArea);

  function DraftAutoScheduleArea(props) {
    var _this;

    _classCallCheck(this, DraftAutoScheduleArea);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getAdjustedTime", function (timestring) {
      return moment.utc(timestring).add(_this.props.timezone.utc_offset.hours, 'hours').add(_this.props.timezone.utc_offset.minutes, 'minutes');
    });

    _defineProperty(_assertThisInitialized(_this), "getUtcTime", function (timestring) {
      return moment.utc(timestring).subtract(_this.props.timezone.utc_offset.hours, 'hours').subtract(_this.props.timezone.utc_offset.minutes, 'minutes');
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateSelect", function (incomingMoment) {
      var organizationId = _this.props.organizationId;
      var newMoment = moment(_this.props.composeboxForm.DraftPost.suggestedPublishAt);
      newMoment.date(incomingMoment.date());
      newMoment.month(incomingMoment.month());
      newMoment.year(incomingMoment.year());

      _this.props.setDraftPostAutoPublishAt(newMoment.valueOf(), organizationId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTimeSelect", function (incomingMoment) {
      var organizationId = _this.props.organizationId;

      _this.props.setDraftPostAutoPublishAt(incomingMoment.valueOf(), organizationId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleQueuedPost", function () {
      var organizationId = _this.props.organizationId;

      _this.props.toggleQueuedPost(organizationId);
    });

    _this.state = {
      displayedDate: moment()
    };
    return _this;
  }

  _createClass(DraftAutoScheduleArea, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          composeboxForm = _this$props.composeboxForm,
          organizationId = _this$props.organizationId,
          loadingPosts = _this$props.loadingPosts;
      var publishAtMoment = this.getAdjustedTime(composeboxForm.DraftPost.suggestedPublishAt);
      var formattedPostTime = /*#__PURE__*/React.createElement("span", {
        className: styles.postDateTime
      }, /*#__PURE__*/React.createElement("span", null, publishAtMoment.format('MMMM Do, YYYY')), /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: 10
        }
      }, publishAtMoment.format('h:mm A')));
      var loadingPostsSpinner = /*#__PURE__*/React.createElement("div", null, loadingPosts && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-spinner fa-spin",
        style: {
          color: '#616161',
          fontSize: 36
        }
      })));
      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(DatePicker, {
        style: {
          width: '100%'
        },
        loadingPosts: loadingPostsSpinner,
        open: true,
        displayedDate: this.state.displayedDate,
        onRequestDecrementMonth: function onRequestDecrementMonth(currentDate) {
          var newDate = moment(currentDate).subtract(1, 'month');

          _this2.setState({
            displayedDate: newDate
          });

          _this2.props.loadPosts(_this2.props.organization.id, _this2.props.selectedTimezone, newDate.startOf('month').toDate(), newDate.endOf('month').toDate(), false);
        },
        onRequestIncrementMonth: function onRequestIncrementMonth(currentDate) {
          var newDate = moment(currentDate).add(1, 'month');

          _this2.setState({
            displayedDate: newDate
          });

          _this2.props.loadPosts(_this2.props.organization.id, _this2.props.selectedTimezone, newDate.startOf('month').toDate(), newDate.endOf('month').toDate(), false);
        },
        selectedDate: moment(composeboxForm.DraftPost.suggestedPublishAt),
        minDate: moment().toDate(),
        maxDate: composeboxForm.maxDate ? moment(composeboxForm.maxDate).toDate() : undefined,
        onDateSelected: function onDateSelected(date) {
          _this2.props.setDraftPostAutoPublishAt(date.getTime(), _this2.props.organization.id);
        },
        eventsOnDay: function eventsOnDay(day) {
          return _this2.props.schedulePostMap["".concat(moment(day).startOf('day').valueOf())] || [];
        }
      }));
    }
  }]);

  return DraftAutoScheduleArea;
}(Component)) || _class);
export { DraftAutoScheduleArea as default };